import { type FC } from "react";

import { InputCheckbox } from "../../InputCheckbox";
import { type TableCellValueCommonProps } from "./types";

export type TableCellValueCheckboxProps = TableCellValueCommonProps & { label?: string };

export const TableCellValueCheckbox: FC<TableCellValueCheckboxProps> = ({
	value,
	defaultValue,
	onChange,
	isEditable,
	label,
}) => {
	let checked = false;

	if (value === true) {
		checked = true;
	} else if (defaultValue === true) {
		checked = true;
	}

	if (!isEditable) {
		return checked ? <>✅</> : <>🚫</>;
	}

	return (
		<InputCheckbox
			size="sm"
			isSelected={checked}
			onChange={onChange}
			isDisabled={!isEditable}
			aria-label={label}
		/>
	);
};
